import react, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "./Header";
import apiService from '../Services/apiService';
import '../styles/Profile.css';
import Logo from '../Asset/Images/logo.svg';
import { Modal, Button, Box, Typography } from '@mui/material';

const Profile = () => {
    const Token = localStorage.getItem("JWTToken");
    const Redirect = useNavigate();
    const [userImgUrl, setUserImgUrl] = useState("");
    const [UserName, setUserName] = useState("");
    const [UserEmail, setUserEmail] = useState("");
    const [EmailVerified, setEmailVerified] = useState("");
    const [MobileVerified, setMobileVerified] = useState(false);
    const [PhoneNumber, setPhoneNumber] = useState("");
    const [LastLogin, setLastLogin] = useState("");
    const [UserEmailDataHas, setUserEmailDataHas] = useState(true);
    const [formData, setFormData] = useState({
        SendByMail: '',
        EmailPassword: '',
        PortNumber: ''
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [errors, setErrors] = useState({
        SendByMail: '',
        EmailPassword: '',
        PortNumber: ''
    });
    const [uploadModal, setUploadModal] = useState(false);
    const [PhoneVerifyModal, setPhoneVerifyModal] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [UploadedFile, setUploadedFile] = useState(null);
    const [ProfileModal, setProfileModal] = useState(false);
    const [Gender, setGender] = useState("");
    const [PinCode, setPinCode] = useState("");
    const [UserAddress, setUserAddress] = useState("");
    const [UserCity, setUserCity] = useState("");
    const [UserCountry, setUserCountry] = useState("");
    const [UserState, setUserState] = useState("");
    const [SocialMedia, setSocialMedia] = useState("");
    const [SocialMediaVerified, setSocialMediaVerify] = useState("");

    useEffect(() => {
        const fetchUserData = async () => {
            debugger
            if (Token) {
                try {
                    const response = await apiService.GetUserData(Token);
                    if (response && response.USER_DETAILS) {
                        const userDetails = response.USER_DETAILS;
                        console.log(response)
                        const imgUrl = userDetails[0].ProfileImgUrl;
                        const UserName = userDetails[0].UserName;
                        const UserEmail = userDetails[0].UserEmail;
                        const EmailVerified = userDetails[0].EmailVerified;
                        const MobileVerified = userDetails[0].MobileNoVerified;
                        const PhoneNumber = userDetails[0].UserMobileNumber;
                        const LastLogin = new Date(userDetails[0].UserLastLogin);
                        const formattedDate = LastLogin.toLocaleDateString('en-US', {
                            weekday: 'long', // Full weekday name (e.g., "Monday")
                            year: 'numeric', // Year in numeric form (e.g., "2025")
                            month: 'long', // Full month name (e.g., "January")
                            day: 'numeric', // Day of the month (e.g., "24")
                        });
                        const formattedTime = LastLogin.toLocaleTimeString('en-US', {
                            hour: '2-digit', // 2-digit hour (e.g., "12")
                            minute: '2-digit', // 2-digit minute (e.g., "42")
                            second: '2-digit', // 2-digit second (e.g., "51")
                            hour12: true, // 12-hour format
                        });
                        const FinalLastLogin = formattedDate + " at " + formattedTime;
                        setUserImgUrl(imgUrl);
                        setUserName(UserName);
                        setUserEmail(UserEmail);
                        setEmailVerified(EmailVerified);
                        setMobileVerified(MobileVerified);
                        setPhoneNumber(PhoneNumber);
                        setLastLogin(FinalLastLogin);
                        setGender(userDetails[0].Gender);
                        setPinCode(userDetails[0].PinCode);
                        setUserAddress(userDetails[0].UserAddress);
                        setUserCity(userDetails[0].UserCity);
                        setUserCountry(userDetails[0].UserCountry);
                        setUserState(userDetails[0].UserState);
                        setSocialMedia(userDetails[0].SocialMedia);
                        setSocialMediaVerify(userDetails[0].SocialMediaVerified);
                        if (response.USEREMAIL_DETAILS && response.USEREMAIL_DETAILS.length > 0) {
                            const userEmailDetails = response.USEREMAIL_DETAILS;
                            const SendByMail = userEmailDetails[0].SendByEmail;
                            const EmailPassword = userEmailDetails[0].EmailPassword;
                            const PortNumber = userEmailDetails[0].PortNumber;
                            setFormData({
                                SendByMail: SendByMail,
                                EmailPassword: EmailPassword,
                                PortNumber: PortNumber
                            });
                            setUserEmailDataHas(true)

                        } else {
                            setUserEmailDataHas(false)
                        }
                    }

                } catch (error) {
                    console.error("Error fetching user data:", error);
                }
            } else {
                Redirect("/Login");
            }
        };

        fetchUserData();
    }, [Token])

    const handleOpen = () => setIsModalOpen(true);
    const handleClose = () => setIsModalOpen(false);

    const handleInputChange = (event) => {
        const { id, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };
    const handleProfileInputChange = (event) => {
        const { id, value } = event.target;
        if (id === "UserName") {
            setUserName(value);
        } else if (id === "PhoneNumber") {
            setPhoneNumber(value);
        }
    }
    const ValidateEmailDetailsForm = () => {
        const newErrors = {};

        // Validate SendByMail (email)
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!formData.SendByMail) {
            newErrors.SendByMail = 'Email is required';
        } else if (!emailRegex.test(formData.SendByMail)) {
            newErrors.SendByMail = 'Please enter a valid email address';
        }

        // Validate EmailPassword
        if (!formData.EmailPassword) {
            newErrors.EmailPassword = 'Password is required';
        }
        // } else if (formData.EmailPassword.length < 6) {
        //   newErrors.EmailPassword = 'Password must be at least 6 characters long';
        // }

        // Validate PortNumber
        if (!formData.PortNumber) {
            newErrors.PortNumber = 'Port number is required';
        } else if (formData.PortNumber < 1 || formData.PortNumber > 65535) {
            newErrors.PortNumber = 'Please enter a valid port number between 1 and 65535';
        }

        setErrors(newErrors);

        // Return true if no errors are present
        return Object.keys(newErrors).length === 0;
    };
    const HandleEmailDetailsSubmit = async (event) => {
        event.preventDefault();
        try {
            if (ValidateEmailDetailsForm()) {
                const Response = await apiService.CreateOrUpdateEmailDetails(Token, formData.SendByMail, formData.EmailPassword, formData.PortNumber);
                if (Response) {
                    setUploadModal(false);
                    alert("Email Details Add Successfully");
                }
            }
        } catch (error) {
            console.log(error)
        }
    };
    const handleOpenModal = () => setUploadModal(true);
    const handleCloseModal = () => setUploadModal(false);
    const handleProfileOpenModal = () => setProfileModal(true);
    const handlePhoneVerifyOpenModal = () => setPhoneVerifyModal(true);
    const handlePhoneVerifyCloseModal = () => setPhoneVerifyModal(false);

    const handleProfileCloseModal = () => {
        setProfileModal(false);
    }
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setUploadedFile(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreviewImage(e.target.result); // Set preview image
            };
            reader.readAsDataURL(file);
        }
    };
    const handleImageUpload = async () => {
        try {
            if (UploadedFile) {
                const ProfileForm = new FormData();
                ProfileForm.append('Token', Token);
                ProfileForm.append('Image', UploadedFile)
                const response = await apiService.UpdateProfileImage(ProfileForm);
                if (response) {
                    setUploadModal(false);
                    localStorage.setItem("ProfileUrl", previewImage);
                    setUserImgUrl(previewImage);
                    alert("Image uploaded successfully!");
                }
            } else {
                alert("Please choose or take an image first!");
            }
        } catch (error) {

        }
    };
    const VerifiedBadge = () => (
        <img
            src={Logo}
            alt="Verified"
            style={{ width: "18px", height: "18px", marginLeft: "5px" }}
        />
    );
    const HandleProfileSubmit = async () => {
        debugger;
        if (UserName === "" || PhoneNumber === "") {
            alert("Name OR PhoneNumber can not be blank.");
            return;
        }

        try {
            const response = await apiService.UpdateProfileData(  UserName,
                PhoneNumber,
                Gender,
                UserCity,
                PinCode,
                UserState,
                UserCountry,
                UserAddress,
                SocialMedia,
                Token);
            if (response) {
                setProfileModal(false);
                alert("Updated Successfully");
            }
        } catch (error) {
            console.error(error);
        }
    }
    return (<>
        <Header />
        <div className='min-hight85vh bg-grey pb-4'>
            <div className='LightGreen p-3'>
                <div className='mx-auto pt-5' style={{ height: "120px", width: "140px" }}>
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            handleOpenModal();
                        }}
                        className='cursor'>
                        <div className="circular-border-container">
                            <div className="circular-border">
                                <img src={userImgUrl} alt="" className='w-100 ImgBorderWithRadius' />
                            </div>
                        </div>
                    </a>
                    <div className='text-end cursor' onClick={handleOpenModal}>
                        <i className="fa-solid fa-pen"></i>
                    </div>
                </div>

                <Modal
                    open={uploadModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description">
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            p: 4,
                            borderRadius: 2,
                            textAlign: 'center',
                            width: 300,
                        }}>
                        <Typography id="modal-title" variant="h6" component="h2" mb={2}>

                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            component="label"
                            sx={{ mb: 2, width: '100%' }}
                        >
                            Upload a Image
                            <input
                                type="file"
                                hidden
                                onChange={handleFileUpload}
                            />
                        </Button>

                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleCloseModal}
                            sx={{ width: '100%' }}
                        >
                            Close
                        </Button>


                        {/* Preview Section */}
                        {previewImage && (
                            <Box mt={3}>
                                <Typography variant="subtitle1" mb={1}>
                                    Preview:
                                </Typography>
                                <div className='mx-auto mb-3' style={{ height: "120px", width: "140px" }}>
                                    <img
                                        src={previewImage}
                                        alt="Preview"
                                        className='ImgBorderWithRadius w-100'
                                    />
                                </div>
                            </Box>
                        )}

                        {/* Upload Button */}
                        {previewImage && (
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{ mt: 2, width: '100%' }}
                                onClick={handleImageUpload}
                            >
                                Upload
                            </Button>
                        )}
                    </Box>
                </Modal>

            </div>
            <div className='ProfileDivSet container'>
                <h5 className='text-center'>{UserEmail}
                    {EmailVerified && <VerifiedBadge />}
                </h5>
                <div className='row'>
                    <div className='col-6'>
                        <div className="row mb-3">
                            <div className="col-3"><label className="nav-link p-2 fs-14 br-none">User Name</label></div>
                            <div className="col-7">
                                <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={UserName || ""} onChange={(e) => setUserEmail(e.target.value)} />
                            </div>

                        </div>
                        <div className="row mb-3">
                            <div className="col-3"><label className="nav-link p-2 fs-14 br-none">PhoneNumber</label></div>
                            <div className="col-7">
                                <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={PhoneNumber || ""} onChange={(e) => setPhoneNumber(e.target.value)} />
                            </div>
                            <div className="col-2">
                                {MobileVerified === 'true' ?
                                    (<>{<VerifiedBadge />}</>) :
                                    (<>
                                        <a className='text-primary cursor' onClick={handlePhoneVerifyOpenModal}>Verify</a>

                                        <Modal
                                            open={PhoneVerifyModal}
                                            onClose={handlePhoneVerifyCloseModal}
                                            aria-labelledby="modal-title"
                                            aria-describedby="modal-description"
                                        >
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    bgcolor: 'background.paper',
                                                    borderRadius: 2,
                                                    boxShadow: 24,
                                                    p: 4,
                                                    width: 600,
                                                }}
                                            >
                                                <h4 id="modal-title" className="text-center" sx={{ mt: 2 }}>
                                                    Verify Phone Number
                                                </h4>
                                                <Typography id="modal-description" sx={{ mt: 2 }}>
                                                    <div>
                                                        <div className="row">
                                                            <div className="my-3">
                                                                <label htmlFor="PhoneNumber">Phone Number</label>
                                                                <input
                                                                    type="tel"
                                                                    id='PhoneNumber'
                                                                    value={PhoneNumber.replace("+91-", "")}
                                                                    onChange={handleProfileInputChange}
                                                                    className='Sanket-Control'
                                                                    placeholder="Enter Phone Number"
                                                                    // maxLength={10}
                                                                    readOnly={true}
                                                                />
                                                                <button className='btn btn-light mt-3'>Send OTP</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Typography>
                                                <Box sx={{ mt: 3 }}>
                                                    <button className="text-dark ActionBtns" onClick={handlePhoneVerifyCloseModal}>
                                                        Close
                                                    </button>
                                                    <button
                                                        className={`py-1 px-5 border-0 Gold br-5`}
                                                        onClick={HandleProfileSubmit}
                                                    > Verify</button>
                                                </Box>
                                            </Box>
                                        </Modal>
                                    </>)
                                }
                            </div>
                        </div>
                    </div>
                    <div className='col-6 text-end'>
                        <p>Last Login:-  {LastLogin}</p>
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className='col-6'>
                        <div className="row mb-3">
                            <div className="col-3"><label className="nav-link p-2 fs-14 br-none">Gender</label></div>
                            <div className="col-7">
                                <select
                                    name="gender"
                                    id="gender"
                                    className="nav-link p-2 fs-14 br-none border bg-white text-black w-100"
                                    value={Gender || ""}
                                    onChange={(e) => setGender(e.target.value)}
                                >
                                    <option value="" className=''>--Select Gender--</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-3"><label className="nav-link p-2 fs-14 br-none">City</label></div>
                            <div className="col-7">
                                <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={UserCity || ""} onChange={(e) => setUserCity(e.target.value)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-3"><label className="nav-link p-2 fs-14 br-none">PinCode</label></div>
                            <div className="col-7">
                                <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={PinCode || ""} onChange={(e) => setPinCode(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="row mb-3">
                            <div className="col-2"><label className="nav-link p-2 fs-14 br-none">State</label></div>
                            <div className="col-7">
                                <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={UserState || ""} onChange={(e) => setUserState(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-2"><label className="nav-link p-2 fs-14 br-none">Country</label></div>
                            <div className="col-7">
                                <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={UserCountry || ""} onChange={(e) => setUserCountry(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-2"><label className="nav-link p-2 fs-14 br-none">Address</label></div>
                            <div className="col-7">
                                <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={UserAddress || ""} onChange={(e) => setUserAddress(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="row mb-3">
                            <div className="col-3"><label className="nav-link p-2 fs-14 br-none">Social Media</label></div>
                            <div className="col-7">
                                <input type="text" className="nav-link p-2 fs-14 br-none border bg-white text-black w-100" value={SocialMedia || ""} onChange={(e) => setSocialMedia(e.target.value)} />
                            </div>
                            <div>
                                {SocialMediaVerified && <VerifiedBadge />}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='text-end'>
                    <button
                        className={`py-2 px-4 border-0 btn-custom br-5`}
                        onClick={HandleProfileSubmit}
                    > Save</button>
                </div>

                {/* <div className='mt-4'>
                    <h5>Email Details :-</h5>
                    {
                        UserEmailDataHas ? (<>
                            <div className='row text-center p-2'>
                                <div className='col-4'>Mail Send By :- {formData.SendByMail}</div>
                                <div className='col-4'>Mail Password :- {formData.EmailPassword}</div>
                                <div className='col-4'>Port :- {formData.PortNumber}</div>
                            </div>
                            <p className='text-end'>
                                <button className='border-0 px-3 py-2 btn-custom' onClick={handleOpen}><i className="fa-regular fa-pen-to-square"></i></button>
                            </p>
                        </>) : (<>
                            <button className='border-0 px-5 py-2 btn-custom' onClick={handleOpen}>Add </button>
                        </>)
                    }

                    <Modal
                        open={isModalOpen}
                        onClose={handleClose}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                bgcolor: 'background.paper',
                                borderRadius: 2,
                                boxShadow: 24,
                                p: 4,
                                width: 600,
                            }}
                        >
                            <h4 id="modal-title" className="text-center" sx={{ mt: 2 }}>
                                Email Details
                            </h4>
                            <Typography id="modal-description" sx={{ mt: 2 }}>
                                <div>
                                    <div className="row">
                                        <div className="">
                                            <label htmlFor="SendByMail">Send By Mail</label>
                                            <input
                                                type="text"
                                                id="SendByMail"
                                                value={formData.SendByMail}
                                                onChange={handleInputChange}
                                                placeholder="Enter mail"
                                                className='Sanket-Control'
                                            />
                                            {errors.SendByMail && <span className="error text-danger">{errors.SendByMail}</span>}
                                        </div>
                                        <div className="my-3">
                                            <label htmlFor="EmailPassword">Email Password</label>
                                            <input
                                                type="password"
                                                id="EmailPassword"
                                                value={formData.EmailPassword}
                                                onChange={handleInputChange}
                                                className='Sanket-Control'
                                                placeholder="Enter password"
                                            />
                                            {errors.EmailPassword && <span className="error text-danger">{errors.EmailPassword}</span>}

                                        </div>
                                        <div className="">
                                            <label htmlFor="PortNumber">Port Number</label>
                                            <input
                                                type="number"
                                                id="PortNumber"
                                                value={formData.PortNumber}
                                                className='Sanket-Control'
                                                onChange={handleInputChange}
                                                placeholder="Enter port number"
                                            />
                                            {errors.PortNumber && <span className="error text-danger">{errors.PortNumber}</span>}

                                        </div>
                                    </div>
                                </div>
                            </Typography>
                            <Box sx={{ mt: 3 }}>
                                <button className="text-dark ActionBtns" onClick={handleClose}>
                                    Close
                                </button>
                                <button
                                    className={`py-1 px-5 border-0 Gold br-5`}
                                    onClick={HandleEmailDetailsSubmit}
                                > Add</button>
                            </Box>
                        </Box>
                    </Modal>

                </div> */}
            </div>
        </div>
    </>)
}
export default Profile